// src/hooks/useAuth.js
// Compatibility hook for components that still use useAuth
import { useApiAuth } from '../contexts/ApiAuthContext';
import { hasPermission as checkPermission, hasRole as checkRole } from '../utils/permissions';

export const useAuth = () => {
  const { user, login, logout } = useApiAuth();
  
  return {
    user,
    login,
    logout,
    isAuthenticated: !!user,
    userRole: user?.role || null,
    
    // Permission checking
    hasPermission: (permission) => checkPermission(user, permission),
    hasRole: (role) => checkRole(user, role),
    
    // Legacy compatibility
    getRoles: () => [user?.role].filter(Boolean),
  };
};
